export default __webpack_public_path__ + "static/media/generalMaintenance.a910c501.jpg";